import { useEffect } from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router'

import { api } from '@/shared/api/base'
import { SetTimezoneDto } from '@synapex/shared'

import { isAuthenticated } from '@/true-fsd/data/isAuthenticated'

async function auth(token: string) {
    const response = await api.authenticate(token)
    if ('error' in response) {
        console.error(response.message, response.error)
        throw new Error(response.error)
    }

    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    await api.post<boolean | null>(`/telegram/settimezone`, {
        userId: response.user.telegram_id,
        prevMessageId: '',
        timezone: timezone,
    } as SetTimezoneDto)
}

export const LoginCallbackPage = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const callbackUrl = queryParams.get('callbackUrl')
    const token = queryParams.get('token')

    useEffect(() => {
        if (token) {
            void auth(token)
                .then(() => {
                    void navigate(callbackUrl ?? '/')
                })
                .catch((error) => {
                    console.log(error)
                    void navigate('/login')
                })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (isAuthenticated()) {
        return <Navigate to={callbackUrl ?? '/'} />
    } else if (!token) {
        return <Navigate to={'/login'} />
    }

    //maybe spinner
    return null
}
